import styles from './GetInStockInfoModal.module.scss';
import { useAdaptiveLayout } from '@/hooks/useAdaptiveLayout';
import { Modal } from '@/atoms/Modal';
import { BottomDrawer } from '@/atoms/BottomDrawer';
import { ModalContentWrapper } from '@/atoms/ModalContentWrapper';
import { Button } from '@/atoms/Button';
import { SuccessActionContent } from '@/atoms/SuccessActionContent';
import { useState } from 'react';
import { Input } from '@/atoms/Input';
import { EMAIL_REGEX } from '@/constants';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { CheckboxField } from '@/atoms/CheckboxField';
import { PersonalDataLabel } from '../PersonalDataLabel';
import { fetchData } from '@/services';
import { FETCH_METHODS } from '@/types';
import toast from 'react-hot-toast';

type GetInStockInfoModalProps = {
  active: boolean;
  onClose: () => void;
  productId: number;
};

type GetInStockInfoModalFormInputs = {
  email: string;
  ads: boolean;
  personalData: boolean;
};

export function GetInStockInfoModal({
  active,
  onClose,
  productId,
}: GetInStockInfoModalProps) {
  const { isTablet } = useAdaptiveLayout();
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState('');

  const methods = useForm<GetInStockInfoModalFormInputs>({
    defaultValues: {
      email: '',
      ads: false,
      personalData: false,
    },
  });

  const fields = useWatch({ control: methods.control });

  const onSubmit = async (data: GetInStockInfoModalFormInputs) => {
    const response = await fetchData({
      url: `/catalog/subscribe/add`,
      method: FETCH_METHODS.POST,
      body: {
        productId,
        email: data.email,
        agreeToReceiveAdMail: data.ads,
        agreeToProcessingPersonalData: data.personalData,
      },
    });

    if (response.success) {
      setEmail(data.email);
      setSuccess(true);
    } else {
      toast.error('Непредвиденная ошибка при подписке на товар');
    }
  };

  const content = (
    <ModalContentWrapper title="Узнать о поступлении">
      <FormProvider {...methods}>
        <form
          className={styles.content}
          onSubmit={methods.handleSubmit(onSubmit)}
        >
          <div className={styles.inputs}>
            <Input
              placeholder="mail@example.com"
              pattern={EMAIL_REGEX}
              name="email"
            />
            <CheckboxField
              label="Я согласен(на) на получение рекламных рассылок"
              name="ads"
            />
            <CheckboxField
              label={<PersonalDataLabel />}
              name="personalData"
              required
            />
          </div>
          <Button
            text="Узнать о поступлении"
            onClick={() => {}}
            type="submit"
            variant="primary"
            disabled={!fields.email || !fields.personalData || !fields.ads}
          />
        </form>
      </FormProvider>
    </ModalContentWrapper>
  );

  if (success) {
    return (
      <>
        <Modal active={active && !isTablet} onClose={onClose} showCloseButton>
          <SuccessActionContent
            title="Вы подписаны на товар"
            description={`Когда товар появится в наличии, вы получите уведомление на ${email}`}
            buttonText="Вернуться к покупкам"
            onClick={onClose}
          />
        </Modal>
        <BottomDrawer active={active && !!isTablet} onClose={onClose}>
          <SuccessActionContent
            title="Вы подписаны на товар"
            description={`Когда товар появится в наличии, вы получите уведомление на ${email}`}
            buttonText="Вернуться к покупкам"
            onClick={onClose}
          />
        </BottomDrawer>
      </>
    );
  }

  return (
    <>
      <Modal active={active && !isTablet} onClose={onClose} showCloseButton>
        {content}
      </Modal>
      <BottomDrawer active={active && !!isTablet} onClose={onClose}>
        {content}
      </BottomDrawer>
    </>
  );
}
